/* FELORA — launch enhancement layer (safe, progressive) */
(function(){
  var F = window.FELORA || {};
  function ready(fn){ if(document.readyState!='loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  ready(function(){
    var header = document.querySelector('#header-component, header, .header, [class*="header-component"]');

    /* 1) sticky blur on scroll */
    if(header){
      var onScroll=function(){ header.classList.toggle('felora-scrolled', window.scrollY>8); };
      onScroll(); window.addEventListener('scroll', onScroll, {passive:true});
    }

    /* 2) active page underline via aria-current */
    try{
      var path=location.pathname.replace(/\/$/,'');
      document.querySelectorAll('header a[href], #header-component a[href]').forEach(function(a){
        var h=(a.getAttribute('href')||'').replace(/\/$/,'');
        if(h && h===path){ a.setAttribute('aria-current','page'); }
      });
    }catch(e){}

    /* 3) inject Talabat pill in header (desktop) — hidden if URL blank */
    if(F.talabatUrl && header && !header.querySelector('.felora-header-talabat')){
      var actions = header.querySelector('[class*="header-actions"], [class*="actions"], .header__actions') || header;
      var a=document.createElement('a');
      a.href=F.talabatUrl; a.target='_blank'; a.rel='noopener';
      a.className='talabat-cta talabat-cta--primary talabat-cta--pill felora-header-talabat';
      a.textContent=F.talabatLabel||'Order on Talabat';
      actions.appendChild(a);
    }
    /* 4c) Talabat pill pinned at bottom of mobile drawer */
    var drawer=document.querySelector('.menu-drawer, .header-drawer, .header__drawer');
    if(drawer && F.talabatUrl && !drawer.querySelector('.felora-drawer-talabat')){
      var d=document.createElement('a'); d.href=F.talabatUrl; d.target='_blank'; d.rel='noopener';
      d.className='talabat-cta talabat-cta--primary talabat-cta--full felora-drawer-talabat';
      d.textContent=F.talabatLabel||'Order on Talabat'; drawer.appendChild(d);
    }
  });
})();
